import { useEffect, useState } from 'react';
import { contarResultadosPendentes, EVENTO_RESULTADOS, iniciarFilaResultados, sincronizarResultados } from '@/services/filaResultados';

export default function ResultadosPendentes() {
  const [total, setTotal] = useState(contarResultadosPendentes);
  const [enviando, setEnviando] = useState(false);
  useEffect(() => {
    const atualizar = () => setTotal(contarResultadosPendentes());
    const parar = iniciarFilaResultados();
    window.addEventListener(EVENTO_RESULTADOS, atualizar);
    window.addEventListener('storage', atualizar);
    return () => {
      parar();
      window.removeEventListener(EVENTO_RESULTADOS, atualizar);
      window.removeEventListener('storage', atualizar);
    };
  }, []);
  if (!total) return null;
  return <aside role="status" style={{ position: 'fixed', bottom: 'calc(80px + env(safe-area-inset-bottom))', left: 12, right: 12,
    margin: '0 auto', maxWidth: 540, padding: 12, borderRadius: 10, background: '#fff4d6', color: '#503500',
    border: '1px solid #dab866', zIndex: 1200, boxShadow: '0 2px 12px #0002', fontSize: 14 }}>
    <strong>{total} {total === 1 ? 'jogo por enviar' : 'jogos por enviar'}</strong>
    <p style={{ margin: '4px 0' }}>Guardado neste dispositivo. Mantém a app aberta com internet e a tua sessão iniciada para enviar.</p>
    <button type="button" disabled={enviando} onClick={async () => {
      setEnviando(true);
      try { await sincronizarResultados(true); }
      catch { /* mantém o aviso e permite tentar novamente */ }
      finally { setEnviando(false); setTotal(contarResultadosPendentes()); }
    }} style={{ fontWeight: 600, textDecoration: 'underline' }}>
      {enviando ? 'A tentar enviar…' : 'Tentar enviar agora'}
    </button>
  </aside>;
}
